import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utilities/axios";

const initialState = {
  headquarters: [],
  states: [],
  status: "idle",
  error: null,
  createStatus: "idle",
  createError: null,
  updateStatus: "idle",
  updateError: null,
  deleteStatus: "idle",
  deleteError: null,
  statesStatus: "idle",
  statesError: null,
};

export const fetchHeadquarters = createAsyncThunk(
  "headquarters/fetchHeadquarters",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/headquarters");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch headquarters");
    }
  }
);

export const createHeadquarter = createAsyncThunk(
  "headquarters/createHeadquarter",
  async (headquarterData, { rejectWithValue }) => {
    try {
      const response = await axios.post("/headquarters", headquarterData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to create headquarter");
    }
  }
);

export const updateHeadquarter = createAsyncThunk(
  "headquarters/updateHeadquarter",
  async ({ id, headquarterData }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`/headquarters/${id}`, headquarterData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to update headquarter");
    }
  }
);

export const deleteHeadquarter = createAsyncThunk(
  "headquarters/deleteHeadquarter",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`/headquarters/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to delete headquarter");
    }
  }
);

export const fetchStates = createAsyncThunk(
  "headquarters/fetchStates",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/locations/states");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch states");
    }
  }
);

const headquarterSlice = createSlice({
  name: "headquarter",
  initialState,
  reducers: {
    clearErrors: (state) => {
      state.error = null;
      state.createError = null;
      state.updateError = null;
      state.deleteError = null;
      state.statesError = null;
    },
    clearStatus: (state) => {
      state.status = "idle";
      state.createStatus = "idle";
      state.updateStatus = "idle";
      state.deleteStatus = "idle";
      state.statesStatus = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHeadquarters.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchHeadquarters.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.headquarters = action.payload.data || [];
        console.log( "headquarters", state.headquarters )
        state.error = null;
      })
      .addCase(fetchHeadquarters.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });

    builder
      .addCase(createHeadquarter.pending, (state) => {
        state.createStatus = "loading";
        state.createError = null;
      })
      .addCase(createHeadquarter.fulfilled, (state, action) => {
        state.createStatus = "succeeded";
        if (action.payload.data) {
          state.headquarters.unshift(action.payload.data);
        }
        state.createError = null;
      })
      .addCase(createHeadquarter.rejected, (state, action) => {
        state.createStatus = "failed";
        state.createError = action.payload;
      });

    builder
      .addCase(updateHeadquarter.pending, (state) => {
        state.updateStatus = "loading";
        state.updateError = null;
      })
      .addCase(updateHeadquarter.fulfilled, (state, action) => {
        state.updateStatus = "succeeded";
        if (action.payload.data) {
          const index = state.headquarters.findIndex(
            (hq) => hq._id === action.payload.data._id
          );
          if (index !== -1) {
            state.headquarters[index] = action.payload.data;
          }
        }
        state.updateError = null;
      })
      .addCase(updateHeadquarter.rejected, (state, action) => {
        state.updateStatus = "failed";
        state.updateError = action.payload;
      });

    builder
      .addCase(deleteHeadquarter.pending, (state) => {
        state.deleteStatus = "loading";
        state.deleteError = null;
      })
      .addCase(deleteHeadquarter.fulfilled, (state, action) => {
        state.deleteStatus = "succeeded";
        if (action.payload.data) {
          state.headquarters = state.headquarters.filter(
            (hq) => hq._id !== action.payload.data._id
          );
        }
        state.deleteError = null;
      })
      .addCase(deleteHeadquarter.rejected, (state, action) => {
        state.deleteStatus = "failed";
        state.deleteError = action.payload;
      });

    builder
      .addCase(fetchStates.pending, (state) => {
        state.statesStatus = "loading";
        state.statesError = null;
      })
      .addCase(fetchStates.fulfilled, (state, action) => {
        state.statesStatus = "succeeded";
        state.states = action.payload.data || [];
        state.statesError = null;
      })
      .addCase(fetchStates.rejected, (state, action) => {
        state.statesStatus = "failed";
        state.statesError = action.payload;
      });
  },
});

export const { clearErrors, clearStatus } = headquarterSlice.actions;
export default headquarterSlice.reducer; 